import React from "react";

const Svg = ({width = 31}: {width?: number} = {}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1802_1042)">
        <path
          d="M29.8092 1.19078L1.1908 29.8092"
          stroke="black"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.1908 1.19078L29.8092 29.8092"
          stroke="black"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1802_1042">
          <rect width="31" height="31" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Svg;
